import { REGIONS, ENVS } from '@adsk/bim360-matrix-react-helpers/es/consts';

export const CONFIG_KEYS = {
  ASSETS_BE: 'ASSETS_BE',
  ASSETS_FE: 'ASSETS_FE'
};

const US_CONFIG = {
  [ENVS.DEV]: {
    [CONFIG_KEYS.ASSETS_BE]: 'https://developer-stg.api.autodesk.com/bim360/assets-dev/v1/projects',
    [CONFIG_KEYS.ASSETS_FE]: 'https://assets.b360-dev.autodesk.com'
  },
  [ENVS.QA]: {
    [CONFIG_KEYS.ASSETS_BE]: 'https://developer-stg.api.autodesk.com/bim360/assets-dev/v1/projects',
    [CONFIG_KEYS.ASSETS_FE]: 'https://assets.b360-qa.autodesk.com'
  },
  [ENVS.STAGING]: {
    [CONFIG_KEYS.ASSETS_BE]: 'https://developer-stg.api.autodesk.com/bim360/assets/v1/projects',
    [CONFIG_KEYS.ASSETS_FE]: 'https://assets.b360-staging.autodesk.com'
  },
  [ENVS.PROD]: {
    [CONFIG_KEYS.ASSETS_BE]: 'https://developer.api.autodesk.com/bim360/assets/v1/projects',
    [CONFIG_KEYS.ASSETS_FE]: 'https://assets.b360.autodesk.com'
  }
};

export const ENV_CONFIG = {
  [REGIONS.US]: US_CONFIG,
  [REGIONS.EMEA]: {
    [ENVS.DEV]: US_CONFIG[ENVS.DEV],
    [ENVS.QA]: US_CONFIG[ENVS.QA],
    [ENVS.STAGING]: {
      ...US_CONFIG[ENVS.STAGING],
      [CONFIG_KEYS.ASSETS_FE]: 'https://assets.b360-staging.eu.autodesk.com'
    },
    [ENVS.PROD]: {
      ...US_CONFIG[ENVS.PROD],
      [CONFIG_KEYS.ASSETS_FE]: 'https://assets.b360.eu.autodesk.com'
    }
  }
};

// Taken from https://git.autodesk.com/BIM360/assets-ui-web/blob/develop/src/consts.ts#L39
//    export const defaultAssetStatusColor: Extract<StatusColor, 'gray'> = 'gray';
export const DEFAULT_ASSET_STATUS_COLOR = 'gray';
